import styled from 'styled-components';

const ItemWrapper = styled.div`

.tab-list {
  font-size: 13px;
}

.tab-list-item {
  display: inline-block;
  border-bottom: 1px solid rgba(255, 0, 0, 0);;
  margin: 0 10px;
  padding: 10px 3px;
  cursor: pointer;
}

.tab-list-active {
  color: ${(props) => props.theme.colors.main_cta};
  display: inline-block;
  border-bottom: 1px solid ${(props) => props.theme.colors.main_cta};
  margin: 0 10px;
  padding: 10px 3px;
  font-weight: bold;
  cursor: pointer;
}

.tab-content {
  margin: 30px 0 0 10px;

}
`;

export default { ItemWrapper };
